import { render, staticRenderFns } from "./CreateContactSidebar.vue?vue&type=template&id=6cf21ad6&scoped=true"
import script from "./CreateContactSidebar.vue?vue&type=script&lang=js"
export * from "./CreateContactSidebar.vue?vue&type=script&lang=js"
import style0 from "./CreateContactSidebar.vue?vue&type=style&index=0&id=6cf21ad6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cf21ad6",
  null
  
)

export default component.exports